import { Outlet, useParams } from 'react-router-dom'
import useSWR from 'swr'

import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'
import UserList from './UserList'
import IssueBotDialog from './IssueBot'

/** Bot 管理：签发入口 + bot 列表，右侧为选中 bot 的权限配置与 token 轮换 */
const BotsPage = () => {
  const { id } = useParams()
  const { data: users } = useSWR(['/users'])
  const bots = users?.filter((u) => u.kind === 'bot')

  return (
    <div className="flex flex-col gap-4 md:flex-row">
      <Card className="md:w-1/4 lg:w-1/5">
        <CardHeader>
          <CardTitle className="text-base">Bot</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          <IssueBotDialog />
          <UserList users={bots} emptyText="还没有 bot，点上方按钮签发。" />
        </CardContent>
      </Card>
      <div className="flex-1 min-w-0">
        {id ? (
          <Outlet />
        ) : (
          <p className="p-4 text-sm text-muted-foreground">
            从左侧选择一个 bot 查看权限，或签发新的 bot。Bot 无飞书身份，凭 token
            作为 x-user-id 调用接口，权限字段与真人同一套。
          </p>
        )}
      </div>
    </div>
  )
}

export default BotsPage
